// extracted by mini-css-extract-plugin
module.exports = {"submitBox":"submitBox--UDaju"};